export default __webpack_public_path__ + "static/media/address-empty.15741853.svg";